import React, { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "./AuthContext";
import { get, post } from "../lib/api";
const CartContext = createContext({ items: [], ready: false });
export const useCart = () => useContext(CartContext);
export function CartProvider({ children }) {
  const { user, loading } = useAuth();
  const [items, setItems] = useState([]);
  const [ready, setReady] = useState(false);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    if (loading) return;
    let active = true;
    setReady(false);
    setItems([]);
    setError("");
    if (user && user.role !== "CUSTOMER") {
      setReady(true);
      return;
    }
    (async () => {
      try {
        const response = user
          ? await post("/cart/merge", {})
          : await get("/cart");
        if (active) {
          setItems(response.cart || []);
          setReady(true);
        }
      } catch (err) {
        if (active) {
          setError(
            err.response?.data?.message || "Unable to load your saved cart.",
          );
          setReady(true);
        }
      }
    })();
    return () => {
      active = false;
    };
  }, [user, loading, retry]);
  useEffect(() => {
    const update = (event) => setItems(event.detail);
    const adjusted = () =>
      setNotice(
        "Some quantities were reduced to the available stock when your carts were merged. Please review your cart.",
      );
    window.addEventListener("cart-adjusted", adjusted);
    window.addEventListener("cart-updated", update);
    return () => {
      window.removeEventListener("cart-updated", update);
      window.removeEventListener("cart-adjusted", adjusted);
    };
  }, []);
  return (
    <CartContext.Provider value={{ items, ready, error }}>
      {notice && (
        <div role="status" className="bg-amber-50 p-3 text-center">
          {notice}{" "}
          <button className="underline" onClick={() => setNotice("")}>
            Dismiss
          </button>
        </div>
      )}
      {error && (
        <div role="alert" className="bg-amber-50 p-3 text-center">
          {error}{" "}
          <button
            className="underline"
            onClick={() => setRetry((value) => value + 1)}
          >
            Retry cart sync
          </button>
        </div>
      )}
      {children}
    </CartContext.Provider>
  );
}
